import { notification } from 'antd';

import codeMessage from './codeMessage';

const successHandler = (response, options = { notifyOnSuccess: false, notifyOnFailed: true }) => {
  const { data } = response;
  if (data && data.success === true) {
    const message = response?.data?.strMessage;
    const successText = message || codeMessage[response.status];

    if (options.notifyOnSuccess) {
      notification.config({
        duration: 5,
      });
      notification.success({
        message: `Request success`,
        description: successText,
      });
    }
  } else {
    const message =response?.data?.strMessage;;
    const errorText = message || codeMessage[response.status];
    const { status } = '400'
    if (options.notifyOnFailed) {
      notification.config({
        duration: 5,
      });
      notification.error({
        message: `Request error 400`,
        description: errorText,
      });
    }
  }
};

export default successHandler;
